import { Observable } from "rxjs";

import * as http from "../../../services/http.service";
import { TWorkOrderResults } from "../../../redux/reducers/workOrdersReducer";
import { SearchResults } from "../../../types/search/search-results.interface";

export function fetchWorkOrders(briefId: number): Observable<SearchResults<TWorkOrderResults>> {
  return http.get("/work-orders/", { params: { execution_brief_id: briefId, minimal: true } });
}
